var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['font-xsmall font-blue-dark font-sf-regular', _vm.className]},[_c('i',{staticClass:"fas fa-check-circle"}),_vm._v(" Verified")])}
var staticRenderFns = []

export { render, staticRenderFns }